import { render, staticRenderFns } from "./restore-code-modal.vue?vue&type=template&id=2aeba0e3"
import script from "./restore-code-modal.vue?vue&type=script&lang=js"
export * from "./restore-code-modal.vue?vue&type=script&lang=js"
import style0 from "./restore-code-modal.vue?vue&type=style&index=0&id=2aeba0e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VInput: require('/var/www/tubber-new/components/global/v/input.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,BaseModal: require('/var/www/tubber-new/components/global/base-modal.vue').default})
